import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup.PropertyRowWithButton', {
    statusEnabled: '(Enabled)',
    statusDisabled: '(Disabled)',

    buttonEnable: 'Enable',
    buttonDisable: 'Disable',
});
